<template>
  <div id="login">
    <div class="page-content">
      <div class="img-login">
        <img
          src="../img/macs-big-transparent.png"
          alt="img"
          style="max-width: 512px !important"
        />
      </div>
      <div class="content-login">
        <div class="row">
          <div class="col-md-8 content-form-login">
            <div>
              <h1 style="text-align: center;padding-bottom: 20px;">
                Gestion du domaine public routier
              </h1>
              <p class="text-muted">Identifiez-vous</p>
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon icon="user"></font-awesome-icon>
              </span>
              <b-form-input
                v-on:keyup.enter="doLogin"
                v-model="email"
                placeholder="Email"
              ></b-form-input>
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon
                  @click="showHidePass()"
                  :icon="iconEye"
                  class="pointeur"
                ></font-awesome-icon>
              </span>
              <b-form-input
                v-on:keyup.enter="doLogin"
                v-model="password"
                :type="typePassword"
                placeholder="Mot de passe"
              ></b-form-input>
            </div>
            <div class="col-xs-12 no-padding marginTop">
              <router-link to="/forgot-pass">Mot de passe oublié ?</router-link>
            </div>
            <div class="col-xs-12 no-padding marginTop">
              <b-button
                type="button"
                class="btn-block"
                variant="warning"
                @click="doLogin()"
              >
                <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                Je m'identifie
              </b-button>
            </div>
            <div class="col-xs-12 no-padding marginTop">
              <b-button
                type="button"
                class="btn-block"
                variant="success"
                @click="Register()"
              >
                <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                S'inscrire
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  name: "Login",
  data: () => ({
    email: "",
    password: "",
    typePassword: "password",
    iconEye: "eye",
    return: "",
  }),
  methods: {
    ...Vuex.mapActions("Authentification", ["login"]),
    showHidePass: function() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
      this.iconEye = this.iconEye == "eye" ? "eye-slash" : "eye";
    },
    doLogin: function() {
      var user = {
        username: this.email,
        password: this.password,
        // remember_me : false,
      };
      this.login(user);
    },
    Register: function() {
      this.$router.push({ path: "/Register" });
    },
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["authStatus", "isAuthenticated"]),
    ident: {
      get: function() {
        return this.login + "/" + this.password;
      },
      set: function(value) {
        this.return = value;
      },
    }, //,
    // ...vuex.mapGetters('Dossiers', ['engagements'])
  },
};
</script>
